
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ChipSituationTrend',
  props: {
    situationData: {
      type: Object as PropType<any>,
      default: () => ({})
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  setup() {
    const formatTime = (time: number) => {
      if (!time) return '-'
      const date = new Date(time)

      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')

      const hh = String(date.getHours()).padStart(2, '0')
      const mm = String(date.getMinutes()).padStart(2, '0')

      // 判断是否是 00:00
      if (hh == '00' && mm == '00') {
        return `${y}/${m}/${d}`
      }

      // 其他时间显示时分
      return `${y}/${m}/${d} ${hh}:${mm}`
    }

    const formatRate = (rate: number | null | undefined) => {
      if (rate === null || rate === undefined) return '-'
      return (rate * 100).toFixed(2) + '%'
    }

    const valueColorClass = (val: number | null | undefined) => {
      if (!val) return ''
      return val > 0 ? 'red-text' : (val < 0 ? 'green-text' : '')
    }

    const stateColor = (stateStr: string) => {
      if (stateStr === '筹码无序') return 'black-text'
      if (stateStr === '筹码松动') return 'green-text'
      if (stateStr === '筹码集中') return 'orange-text'
      if (stateStr === '筹码稳定') return 'red-text'
      return ''
    }

    const trendColor = (colorCode: number) => {
      if (colorCode === 0) return 'black-text'
      if (colorCode === 1) return 'red-text'
      if (colorCode === 2) return 'green-text'
      return ''
    }

    return {
      formatTime,
      formatRate,
      valueColorClass,
      stateColor,
      trendColor
    }
  }
})
